export const ContactBox = () => {
  return (
    <a href="/kundservice/kontakt" className="text-gray-800 hover:underline">
      <div className="uppercase text-xs">ÖVRIGA FRÅGOR</div>
      <div>
        Undrar du över något annat? Här finns våra vanliga frågor och svar, samt
        hur du kommer i kontakt med oss.
      </div>
    </a>
  );
};
